const ENERGY_BASELINE = 2000;
const SCALING_FACTOR = 0.8;
const SCORE_MAX = 100;

const RANGE_PROFILES = {
  SEA: [
    {
      name: "addedSugarsTeaSpoons",
      units: "tsp",
      weight: 1,
      lhr0: 0.0,
      lhr: 0.0,
      uhr: 11.9047619,
      uhr0: 17.85714286,
    },
    {
      name: "calciumMilligrams",
      units: "mg",
      weight: 1,
      lhr0: 325.0,
      lhr: 750.0,
      uhr: 1500.0,
      uhr0: 1875.0,
    },
    {
      name: "fatSaturatedGrams",
      units: "g",
      weight: 2,
      lhr0: 0.0,
      lhr: 0.0,
      uhr: 22.22222222,
      uhr0: 33.33333333,
    },
    {
      name: "fatTotalGrams",
      units: "g",
      weight: 1,
      lhr0: 22.22222222,
      lhr: 44.44444444,
      uhr: 77.77777778,
      uhr0: 100.0,
    },
    {
      name: "fiberGrams",
      units: "g",
      weight: 1,
      lhr0: 10.0,
      lhr: 20.0,
      uhr: 40.0,
      uhr0: 50.0,
    },
    {
      name: "ironMilligrams",
      units: "mg",
      weight: 1,
      lhr0: 6.0,
      lhr: 12.0,
      uhr: 24.0,
      uhr0: 30.0,
    },
    {
      name: "potassiumMilligrams",
      units: "mg",
      weight: 2,
      lhr0: 1000.0,
      lhr: 2000.0,
      uhr: 4000.0,
      uhr0: 6000.0,
    },
    {
      name: "proteinGrams",
      units: "g",
      weight: 1,
      lhr0: 25.0,
      lhr: 50.0,
      uhr: 75.0,
      uhr0: 100.0,
    },
    {
      name: "sodiumMilligrams",
      units: "mg",
      weight: 1,
      lhr0: 0.0,
      lhr: 0.0,
      uhr: 2000.0,
      uhr0: 3000.0,
    },
  ],
  default: [
    {
      name: "addedSugarsTeaSpoons",
      units: "tsp",
      weight: 1,
      lhr0: 0,
      lhr: 0,
      uhr: 11.9047619,
      uhr0: 17.85714286,
    },
    {
      name: "calciumMilligrams",
      units: "mg",
      weight: 1,
      lhr0: 500,
      lhr: 1000,
      uhr: 2000,
      uhr0: 2500,
    },
    {
      name: "fatSaturatedGrams",
      units: "g",
      weight: 2,
      lhr0: 0,
      lhr: 0,
      uhr: 22.22222222,
      uhr0: 33.33333333,
    },
    {
      name: "fatTotalGrams",
      units: "g",
      weight: 1,
      lhr0: 22.22222222,
      lhr: 44.44444444,
      uhr: 77.77777778,
      uhr0: 100,
    },
    {
      name: "fiberGrams",
      units: "g",
      weight: 1,
      lhr0: 12.5,
      lhr: 25,
      uhr: 50,
      uhr0: 62.5,
    },
    {
      name: "ironMilligrams",
      units: "mg",
      weight: 1,
      lhr0: 9,
      lhr: 18,
      uhr: 36,
      uhr0: 45,
    },
    {
      name: "potassiumMilligrams",
      units: "mg",
      weight: 2,
      lhr0: 1750,
      lhr: 3500,
      uhr: 7000,
      uhr0: 8750,
    },
    {
      name: "proteinGrams",
      units: "g",
      weight: 1,
      lhr0: 25,
      lhr: 50,
      uhr: 175,
      uhr0: 200,
    },
    {
      name: "sodiumMilligrams",
      units: "mg",
      weight: 1,
      lhr0: 0,
      lhr: 0,
      uhr: 2000,
      uhr0: 3000,
    },
  ],
};
const RANGE_PROFILE_KEY = {
  PHL: "SEA",
  VNM: "SEA",
  IDN: "SEA",
  MYS: "SEA",
};

const LIMITS_PER_KCAL = {
  sodiumMilligrams: 150,
  calciumMilligrams: 100,
  fatTotalGrams: 0.1,
  ironMilligrams: 0.45,
  potassiumMilligrams: 75,
  proteinGrams: 0.25,
};

module.exports = {
  ENERGY_BASELINE,
  SCALING_FACTOR,
  SCORE_MAX,
  RANGE_PROFILES,
  LIMITS_PER_KCAL,
  RANGE_PROFILE_KEY,
};
